import React from 'react';
import { BrowserRouter as Router, Route, Routes }  from 'react-router-dom';
import Home from './Home';
import Blog from './Blog';
import Footer from './Footer';
import './Footer.css';
import './Home.css';
import './App.css';
import './LightTile.css';
import './LightGrid.css';
import './SideBar.css';
import './Hero.css';
import './components/PostTile/PostTile.css';
import './components/PostGrid/PostGrid.css';
import Navbar from './Navbar';
import SinglePost from "./SinglePost";
import './Navbar.css';
import './SinglePost.css';
import './PostBody.css';
import './Comment.css';
import './RelatedPosts.css';
import './Blog.css';
import './ContactForm.css';
import './Contact.css';
import Contact from './Contact';
import './Subscribe.css';

export default class App extends React.Component {

  render(){
    return (
      <Router>
        <div className="App">
          <Navbar />
            <Routes>
              <Route path='/' element={<Home />}/>
              <Route path='/blog' element={<Blog />}/>
              <Route path='/contact' element={<Contact />}/>
              <Route exact path='/singlepost/:id' element={<SinglePost />}/>
            </Routes>
          <Footer />
        </div>
      </Router>
    )
  }
}